<div class="pin__input">
  <input
    type="text"
    pattern="[0-9]*"
    autofocus
    autocomplete="off"
    inputmode="numeric"
    [(ngModel)]="pinValue1"
    (keydown)="formatPinInput($event)"
    (keyup)="checkFocusability($event, 2)"
    placeholder="0"
    #pinInput1
  />
  <input
    type="text"
    pattern="[0-9]*"
    autocomplete="off"
    inputmode="numeric"
    [(ngModel)]="pinValue2"
    (keydown)="formatPinInput($event)"
    (keyup)="checkFocusability($event, 3)"
    placeholder="0"
    #pinInput2
  />
  <input
    type="text"
    pattern="[0-9]*"
    autocomplete="off"
    inputmode="numeric"
    [(ngModel)]="pinValue3"
    (keydown)="formatPinInput($event)"
    (keyup)="checkFocusability($event, 4)"
    placeholder="0"
    #pinInput3
  />
  <input
    type="text"
    pattern="[0-9]*"
    autocomplete="off"
    inputmode="numeric"
    [(ngModel)]="pinValue4"
    (keydown)="formatPinInput($event)"
    (keyup)="checkFocusability($event, 5)"
    placeholder="0"
    #pinInput4
  />
</div>
